<template>
  <section v-if="images?.length" class="overflow-hidden mt-30 lg:mt-90">
    <div class="container-desktop 3xl:max-w-edge">
      <Slider
        id="product-images"
        ref="slider"
        class="details-slider"
        arrows
        :panels-per-view="panelsPerView"
      >
        <div
          v-for="(image, i) in images"
          :key="i"
          class="w-full pl-25 md:pl-0 md:mr-20 lg:mr-30"
        >
          <div
            class="details-slider-image w-full cursor-zoom-in aspect-[4/3] flex items-center"
            v-bind="getItemAttributes(i)"
            @click="openLightbox(i)"
          >
            <MediaImage v-bind="image" :image-style="imageStyle" />
          </div>
          <div
            v-if="image.caption"
            class="font-helvetica text-lg font-light mt-20"
            v-html="image.caption"
          />
        </div>
      </Slider>
    </div>
  </section>
</template>

<script lang="ts" setup>
import type { MediaImageFragment } from '#graphql-operations'
import type Slider from '~/components/Slider/index.vue'

const { isMobile } = useViewport()

const props = withDefaults(
  defineProps<{
    images?: MediaImageFragment[]
  }>(),
  {
    images: () => [],
  },
)

const slider = ref<InstanceType<typeof Slider> | null>(null)

const { openLightbox, getItemAttributes } = useLightbox(
  'product-images',
  props.images,
  {
    slider,
    showCaption: true,
  },
)

const panelsPerView = computed(() => (isMobile.value ? 1.5 : 3))

const imageStyle = defineExpedImageStyle({
  type: 'sizes',
  aspectRatio: 4 / 3,
  cropType: 'cover',
  sizes: {
    xs: 450,
    lg: 300,
    xl: 500,
    '3xl': 768,
  },
})
</script>
